import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';

function pathRequiresAuth(url: string): boolean {
  return (
    (url.indexOf('token') < 0 ||
      url.indexOf('user/tokens') > 0 ||
      url.indexOf('email/reset-by-token') > 0 ||
      url.indexOf('auth0-token-exchange') > 0) &&
    url.indexOf('label/public') < 0 &&
    url.indexOf('dbconnections/change_password') < 0
  );
}

export const authHttpHeadersInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const sessionStorage = inject(SessionStorageService);

  if (pathRequiresAuth(request.url)) {
    const userKey = sessionStorage.retrieve('wsb-user-key');
    const userProfileKey = sessionStorage.retrieve('wsb-userprofile-key');
    const accessToken = sessionStorage.retrieve('wsb-access-token');
    const impersonateSubuserKey = sessionStorage.retrieve('wsb-impersonate-subuser-key');
    const igoImpersonator = sessionStorage.retrieve('wsb-igo-impersonator');
    const redirectLogin = sessionStorage.retrieve('wsb-redirect-login');
    const userLogin = sessionStorage.retrieve('wsb-user-login');

    let clonedReq = request.clone({
      headers: request.headers
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
        .set('Expires', '0')
    });

    if (userKey !== null && userProfileKey !== null && accessToken !== null) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers
          .set('user_key', [userKey])
          .set('user_profile_key', [userProfileKey])
          .set('Access_token', [accessToken])
      });
    }

    if (impersonateSubuserKey !== null) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.set('impersonated_subuser_key', [impersonateSubuserKey])
      });
    }
    if (igoImpersonator !== null) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.set('igo_impersonator', [igoImpersonator])
      });
    }
    if (redirectLogin !== null) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.set('redirect_login', [redirectLogin])
      });
    }
    if (userLogin !== null) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.set('user_login', [userLogin])
      });
    }
    return next(clonedReq);
  }
  return next(request);
};
